import type { BaseEntity } from 'c-sdk';

export const sortEntityAsc = (a: BaseEntity, b: BaseEntity) => a.id - b.id;
export const sortEntityDesc = (a: BaseEntity, b: BaseEntity) => b.id - a.id;
